/* 419DRIVER — white storefront behaviour */
(function () {
  'use strict';

  var cartAddUrl = ((window.routes || {}).cart_add_url) || '/cart/add';

  /* ---------- overlay header: solidify once past the hero ---------- */
  function initStickyHeader() {
    var header = document.querySelector('[data-drvr-overlay]');
    if (!header) return;
    var hero = document.querySelector('.drvr-hero');
    var threshold = hero ? Math.max(hero.offsetHeight - 90, 120) : 120;
    function onScroll() {
      header.classList.toggle('is-stuck', window.scrollY > threshold);
    }
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      threshold = hero ? Math.max(hero.offsetHeight - 90, 120) : 120;
      onScroll();
    });
  }

  /* ---------- mega menu ---------- */
  function initMega(root) {
    var triggers = root.querySelectorAll('[data-drvr-mega-trigger]');
    if (!triggers.length) return;
    var closeTimer = null;

    function closeAll() {
      root.querySelectorAll('[data-drvr-mega]').forEach(function (p) { p.setAttribute('data-open', 'false'); });
      triggers.forEach(function (t) { t.setAttribute('aria-expanded', 'false'); });
    }
    function open(id) {
      closeAll();
      var panel = root.querySelector('[data-drvr-mega="' + id + '"]');
      var trigger = root.querySelector('[data-drvr-mega-trigger="' + id + '"]');
      if (!panel) return;
      panel.setAttribute('data-open', 'true');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      root.classList.add('is-stuck');
    }

    triggers.forEach(function (t) {
      var id = t.getAttribute('data-drvr-mega-trigger');
      t.addEventListener('mouseenter', function () { clearTimeout(closeTimer); open(id); });
      t.addEventListener('focus', function () { clearTimeout(closeTimer); open(id); });
      t.addEventListener('click', function (e) {
        if (t.getAttribute('aria-expanded') === 'true') { closeAll(); return; }
        e.preventDefault();
        open(id);
      });
    });
    root.addEventListener('mouseleave', function () { closeTimer = setTimeout(closeAll, 130); });
    root.querySelectorAll('[data-drvr-mega]').forEach(function (p) {
      p.addEventListener('mouseenter', function () { clearTimeout(closeTimer); });
      p.addEventListener('mouseleave', function () { closeTimer = setTimeout(closeAll, 130); });
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });
  }

  /* ---------- mobile drawer ---------- */
  function initDrawer() {
    var drawer = document.querySelector('[data-drvr-drawer]');
    if (!drawer || drawer.dataset.bound === '1') return;
    drawer.dataset.bound = '1';

    function setOpen(state) {
      drawer.setAttribute('data-open', state ? 'true' : 'false');
      document.documentElement.style.overflow = state ? 'hidden' : '';
      if (state) {
        var first = drawer.querySelector('button, a');
        if (first) first.focus();
      }
    }
    document.querySelectorAll('[data-drvr-drawer-open]').forEach(function (b) {
      b.addEventListener('click', function () { setOpen(true); });
    });
    drawer.querySelectorAll('[data-drvr-drawer-close]').forEach(function (b) {
      b.addEventListener('click', function () { setOpen(false); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.getAttribute('data-open') === 'true') setOpen(false);
    });
    drawer.querySelectorAll('button.drvr-acc__head').forEach(function (head) {
      head.addEventListener('click', function () {
        var acc = head.closest('.drvr-acc');
        var open = acc.getAttribute('data-open') === 'true';
        acc.setAttribute('data-open', open ? 'false' : 'true');
        head.setAttribute('aria-expanded', open ? 'false' : 'true');
        var sign = head.querySelector('[data-sign]');
        if (sign) sign.textContent = open ? '+' : '−';
      });
    });
  }

  /* ---------- marquee-style loops ---------- */
  function initLoops() {
    document.querySelectorAll('[data-drvr-loop]').forEach(function (track) {
      if (track.dataset.drvrLooped === '1') return;
      track.dataset.drvrLooped = '1';
      track.innerHTML = track.innerHTML + track.innerHTML;
    });
  }

  /* ---------- card: "+" reveals the size tray ---------- */
  function initSizeToggles(scope) {
    (scope || document).querySelectorAll('[data-drvr-sizetoggle]').forEach(function (btn) {
      if (btn.dataset.bound === '1') return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var top = btn.closest('.drvr-card__top');
        var open = top.getAttribute('data-sizes') === 'true';
        document.querySelectorAll('.drvr-card__top[data-sizes="true"]').forEach(function (t) {
          if (t !== top) t.setAttribute('data-sizes', 'false');
        });
        top.setAttribute('data-sizes', open ? 'false' : 'true');
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest('.drvr-card')) return;
      document.querySelectorAll('.drvr-card__top[data-sizes="true"]').forEach(function (t) {
        t.setAttribute('data-sizes', 'false');
      });
    });
  }

  /* ---------- quick add ---------- */
  function initQuickAdd(scope) {
    (scope || document).querySelectorAll('[data-drvr-quickadd]').forEach(function (btn) {
      if (btn.dataset.bound === '1') return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (btn.disabled) return;
        var id = btn.getAttribute('data-variant-id');
        if (!id) return;
        var original = btn.textContent;
        btn.classList.add('is-busy');
        fetch(cartAddUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
        })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
          .then(function (res) {
            btn.classList.remove('is-busy');
            btn.textContent = res.ok ? '✓' : '!';
            if (res.ok) { refreshCartCount(); document.dispatchEvent(new CustomEvent('drvr:added')); }
            setTimeout(function () { btn.textContent = original; }, 1400);
          })
          .catch(function () {
            btn.classList.remove('is-busy');
            btn.textContent = '!';
            setTimeout(function () { btn.textContent = original; }, 1400);
          });
      });
    });
  }

  function refreshCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-drvr-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      })
      .catch(function () {});
  }

  /* ---------- PDP ---------- */
  function initPdp() {
    var form = document.querySelector('[data-drvr-pdp]');
    if (!form || form.dataset.bound === '1') return;
    form.dataset.bound = '1';

    var dataEl = form.querySelector('[data-drvr-variants]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }

    var idInput = form.querySelector('[data-drvr-variant-id]');
    var submit = form.querySelector('[data-drvr-submit]');
    var atcLabel = form.querySelector('[data-drvr-atc-label]');
    var atcPrice = form.querySelector('[data-drvr-atc-price]');
    var priceWrap = document.querySelector('[data-drvr-price]');
    var inputs = form.querySelectorAll('[data-drvr-option]');

    function selected() {
      var out = [];
      form.querySelectorAll('[data-drvr-option]:checked').forEach(function (i) {
        out[Number(i.getAttribute('data-option-index'))] = i.value;
      });
      return out;
    }
    function match(opts) {
      return variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
    }
    function markUnavailable(opts) {
      inputs.forEach(function (input) {
        var idx = Number(input.getAttribute('data-option-index'));
        var found = variants.find(function (v) {
          return v.options.every(function (o, i) {
            if (i === idx) return o === input.value;
            return opts[i] == null || o === opts[i];
          });
        });
        var label = form.querySelector('label[for="' + input.id + '"]');
        if (label) label.setAttribute('data-unavailable', found && found.available ? 'false' : 'true');
      });
    }

    function update() {
      var opts = selected();
      var v = match(opts);
      markUnavailable(opts);

      form.querySelectorAll('[data-drvr-optlabel]').forEach(function (el) {
        var i = Number(el.getAttribute('data-drvr-optlabel'));
        if (opts[i]) el.textContent = opts[i];
      });

      if (!v) {
        if (submit) submit.disabled = true;
        if (atcLabel) atcLabel.textContent = 'Unavailable';
        return;
      }
      if (idInput) idInput.value = v.id;
      if (submit) submit.disabled = !v.available;
      if (atcLabel) atcLabel.textContent = v.available ? 'Add to Cart' : 'Sold out';
      if (atcPrice) atcPrice.textContent = v.price;
      if (priceWrap && v.price_html) priceWrap.innerHTML = v.price_html;
      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    inputs.forEach(function (i) { i.addEventListener('change', update); });
    update();
    // PDP add-to-cart goes through fetch so the drawer can open in place
    form.addEventListener('submit', function (e) {
      if (!idInput || !idInput.value) return;
      e.preventDefault();
      if (atcLabel) atcLabel.textContent = 'Adding…';
      fetch(cartAddUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: 1 }] })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (atcLabel) atcLabel.textContent = res.ok ? 'Added' : 'Try again';
          if (res.ok) { refreshCartCount(); document.dispatchEvent(new CustomEvent('drvr:added')); }
          setTimeout(update, 1200);
        })
        .catch(function () { if (atcLabel) atcLabel.textContent = 'Try again'; setTimeout(update, 1200); });
    });
  }

  /* ---------- PDP thumbnail rail ---------- */
  function initThumbs() {
    var rail = document.querySelector('[data-drvr-thumbs]');
    if (!rail || rail.dataset.bound === '1') return;
    rail.dataset.bound = '1';
    var slides = document.querySelectorAll('[data-drvr-slide]');
    rail.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var i = b.getAttribute('data-index');
        var target = document.querySelector('[data-drvr-slide="' + i + '"]');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
    if ('IntersectionObserver' in window && slides.length) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var i = en.target.getAttribute('data-drvr-slide');
          rail.querySelectorAll('button').forEach(function (b) {
            if (b.getAttribute('data-index') === i) b.setAttribute('aria-current', 'true');
            else b.removeAttribute('aria-current');
          });
        });
      }, { threshold: 0.55 });
      slides.forEach(function (s) { io.observe(s); });
    }
  }

  /* ---------- collection controls ---------- */
  function initViewToggle() {
    var wrap = document.querySelector('[data-drvr-viewtoggle]');
    var grid = document.querySelector('[data-drvr-collection-grid]');
    if (!wrap || !grid || wrap.dataset.bound === '1') return;
    wrap.dataset.bound = '1';
    var stored = null;
    try { stored = localStorage.getItem('drvr-cols'); } catch (e) {}
    if (stored) apply(stored);
    wrap.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () { apply(b.getAttribute('data-cols')); });
    });
    function apply(cols) {
      grid.setAttribute('data-cols', cols);
      wrap.querySelectorAll('button').forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-cols') === cols ? 'true' : 'false');
      });
      try { localStorage.setItem('drvr-cols', cols); } catch (e) {}
    }
  }

  function initFilterToggle() {
    var btn = document.querySelector('[data-drvr-filtertoggle]');
    var form = document.getElementById('DrvrFacets');
    if (!btn || !form || btn.dataset.bound === '1') return;
    btn.dataset.bound = '1';
    btn.addEventListener('click', function () {
      var open = !form.hidden;
      form.hidden = open;
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
    });
  }

  function initSort() {
    var sel = document.querySelector('[data-drvr-sort]');
    if (!sel || sel.dataset.bound === '1') return;
    sel.dataset.bound = '1';
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* Product titles are stored ALL CAPS in Shopify. On a sentence-case layout
     that reads shouty, so present them in Title Case. Data is untouched. */
  var KEEP = { 'DRVR': 1, 'DRIVER': 1, 'AC': 1, 'XL': 1, 'XXL': 1, 'US': 1, 'I': 1 };
  function titleCase(str) {
    return str.replace(/[A-Za-z0-9''\u2019]+/g, function (w) {
      var bare = w.replace(/[^A-Za-z]/g, '').toUpperCase();
      if (KEEP[bare]) return w.toUpperCase();
      if (/\d/.test(w)) return w;
      return w.charAt(0).toUpperCase() + w.slice(1).toLowerCase();
    });
  }
  function initTitleCase(scope) {
    (scope || document).querySelectorAll('.drvr-card__title, .drvr-pdp__title, .drvr-cart__name')
      .forEach(function (el) {
        if (el.dataset.tc === '1') return;
        el.dataset.tc = '1';
        var t = el.textContent.trim();
        if (t === t.toUpperCase()) el.textContent = titleCase(t);
      });
  }

  function boot(scope) {
    document.body.classList.add('drvr');
    document.querySelectorAll('[data-drvr-header]').forEach(initMega);
    initStickyHeader();
    initDrawer();
    initLoops();
    initSizeToggles(scope);
    initQuickAdd(scope);
    initPdp();
    initThumbs();
    initViewToggle();
    initFilterToggle();
    initSort();
    initTitleCase(scope);
    refreshCartCount();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
